import { render } from "./Error.vue?vue&type=template&id=0a2e4770&scoped=true"
const script = {}

import "./Error.vue?vue&type=style&index=0&id=0a2e4770&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2e4770"]])

export default __exports__